import { Theme } from "@mui/material";

export const avatarsContainerStyles = {
  display: "flex",
  flexDirection: "column",
  gap: "10px",
};

export const avatarBoxStyles = (isSelected: boolean, theme: Theme) => ({
  display: "flex",
  alignItems: "center",
  gap: "10px",
  border: isSelected
    ? "2px solid #06B6D4"
    : `2px solid ${theme.palette.outlinedButton.borderColor}`,
  borderRadius: "12px",
  cursor: "pointer",
  p: 1,
});

export const avatarImageStyles = {
  width: 50,
  height: 50,
  borderRadius: "50%",
};

export const textStyles = (theme: Theme) => ({
  fontSize: "18px",
  fontWeight: 600,
  color: theme.palette.modalColors.colorLable,
});
